export function getDaysRemaningText(noOfDays: number) {
  if (noOfDays === 1) {
    return "pozostał 1 dzień";
  }

  return `pozostało ${noOfDays} dni`;
}
